export default "__VITE_ASSET__BZ87snCN__"